import { ReactElement } from 'react';

import { Button, ChakraFlex, ChakraText } from '@equip.health/ui';

const TOP_LEVEL_ID = 'calendar-modal-footer';

interface ModalFooterContentProps {
  handleLeftButtonClick?: () => void;
  handleRightButtonClick?: () => void;
  isLeftButtonDisabled?: boolean;
  isLeftButtonLoading?: boolean;
  isLeftButtonVisible?: boolean;
  isRightButtonDisabled?: boolean;
  isRightButtonLoading?: boolean;
  isRightButtonVisible?: boolean;
  leftButtonIcon?: ReactElement;
  leftButtonText?: string;
  rightButtonIcon?: ReactElement;
  rightButtonText?: string;
}

const ModalFooterContent = ({
  handleLeftButtonClick = () => {},
  handleRightButtonClick = () => {},
  isLeftButtonDisabled = false,
  isLeftButtonLoading = false,
  isLeftButtonVisible = true,
  isRightButtonDisabled = false,
  isRightButtonLoading = false,
  isRightButtonVisible = true,
  leftButtonIcon = null,
  leftButtonText = '',
  rightButtonIcon = null,
  rightButtonText = '',
}: ModalFooterContentProps): ReactElement => {
  return (
    <ChakraFlex justifyContent="space-between" width="100%">
      {isLeftButtonVisible ? (
        <Button
          id={`${TOP_LEVEL_ID}__${leftButtonText.toLowerCase()}-btn`}
          isDisabled={isLeftButtonDisabled}
          isLoading={isLeftButtonLoading}
          leftIcon={leftButtonIcon}
          onClick={handleLeftButtonClick}
          size="md"
          variant="outline"
        >
          <ChakraText
            id={`${TOP_LEVEL_ID}__${leftButtonText.toLowerCase()}-text`}
          >
            {leftButtonText}
          </ChakraText>
        </Button>
      ) : (
        <ChakraText />
      )}
      {isRightButtonVisible && (
        <Button
          id={`${TOP_LEVEL_ID}__${rightButtonText.toLowerCase()}-btn`}
          isDisabled={isRightButtonDisabled}
          isLoading={isRightButtonLoading}
          leftIcon={rightButtonIcon}
          onClick={handleRightButtonClick}
          size="md"
        >
          <ChakraText
            id={`${TOP_LEVEL_ID}__${rightButtonText.toLowerCase()}-text`}
            paddingBottom="1px"
          >
            {rightButtonText}
          </ChakraText>
        </Button>
      )}
    </ChakraFlex>
  );
};

export default ModalFooterContent;
